/** Client for the sk-hire v2 Ops console (Softknack-internal; hire:admin). */
import axiosInstance from '../../api/axiosInstance';
import {
  HireMatch_Ops_Metrics_Url,
  HireMatch_Ops_FeedbackAnalytics_Url,
  HireMatch_Ops_CurationQueue_Url,
  HireMatch_Ops_Skills_Url,
  HireMatch_Ops_CurationPromote_Url,
  HireMatch_Ops_CurationAttach_Url,
  HireMatch_Ops_CurationDiscard_Url,
  HireMatch_Ops_Reextract_Url,
  HireMatch_Ops_TitleQueue_Url,
  HireMatch_Ops_TitlePromote_Url,
  HireMatch_Ops_TitleDiscard_Url,
} from '../../api/endpoints';

export interface OpsMetrics {
  runs: { total: number; ok: number; fallback: number; skipped: number };
  stage4FallbackRate: number;
  stage4SkippedRate: number;
  parseSuccessRate: number;
  parsedProfiles: number;
  tokenUsage: { input: number; output: number; total: number };
  stage2P95Ms: number | null;
  activePoolSize: number;
  annTriggerHit: boolean;
  stage4LatencyMs: number | null;
}
export interface FeedbackAnalytics {
  total: number;
  goodMatch: number;
  falsePositive: number;
  falsePositiveRate: number;
}
export interface CurationEntry {
  id: string;
  rawText: string;
  occurrenceCount: number;
  firstSeenAt: string;
  lastSeenAt: string;
  status: string;
}
export interface CanonicalSkill { id: string; label: string; category: string | null }

export async function getOpsMetrics(): Promise<OpsMetrics> {
  const { data } = await axiosInstance.get<OpsMetrics>(HireMatch_Ops_Metrics_Url);
  return data;
}
export async function getFeedbackAnalytics(): Promise<FeedbackAnalytics> {
  const { data } = await axiosInstance.get<FeedbackAnalytics>(HireMatch_Ops_FeedbackAnalytics_Url);
  return data;
}
export async function getCurationQueue(): Promise<CurationEntry[]> {
  const { data } = await axiosInstance.get<CurationEntry[]>(HireMatch_Ops_CurationQueue_Url);
  return Array.isArray(data) ? data : [];
}
export async function getSkills(): Promise<CanonicalSkill[]> {
  const { data } = await axiosInstance.get<CanonicalSkill[]>(HireMatch_Ops_Skills_Url);
  return Array.isArray(data) ? data : [];
}
export async function promoteCuration(id: string, canonicalLabel: string, category?: string | null): Promise<void> {
  await axiosInstance.post(HireMatch_Ops_CurationPromote_Url(id), { canonicalLabel, category: category ?? null });
}
export async function attachCuration(id: string, skillId: string): Promise<void> {
  await axiosInstance.post(HireMatch_Ops_CurationAttach_Url(id), { skillId });
}
export async function discardCuration(id: string): Promise<void> {
  await axiosInstance.post(HireMatch_Ops_CurationDiscard_Url(id), {});
}
export async function reextract(targetVersion: string): Promise<{ total: number; reextracted: number; skipped: number; noop: number }> {
  const { data } = await axiosInstance.post(HireMatch_Ops_Reextract_Url, { targetVersion });
  return data;
}

/* ── WI-4 (titles) — title curation queue ── */
export async function getTitleQueue(): Promise<CurationEntry[]> {
  const { data } = await axiosInstance.get<CurationEntry[]>(HireMatch_Ops_TitleQueue_Url);
  return Array.isArray(data) ? data : [];
}
export async function promoteTitle(id: string, label: string, familySlug: string): Promise<void> {
  await axiosInstance.post(HireMatch_Ops_TitlePromote_Url(id), { label, familySlug });
}
export async function discardTitle(id: string): Promise<void> {
  await axiosInstance.post(HireMatch_Ops_TitleDiscard_Url(id), {});
}
